var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticClass: "pageSize",
      staticStyle: { margin: "0 auto", "padding-top": "15px" },
    },
    [
      _c("Head", { attrs: { homeTitle: "组合风险评价" } }),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", {
            staticClass: "line_border_bottom el-tabs__item",
            attrs: { span: 1 },
          }),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 23 } },
            [
              _c(
                "el-tabs",
                {
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.ReloadTab },
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "组合风险评价", name: "first" } },
                    [_c("PortfolioRisk", { ref: "portfolioRisk" })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }